import { render, staticRenderFns } from "./DeclareApplyList.vue?vue&type=template&id=af9558cc&scoped=true&"
import script from "./DeclareApplyList.vue?vue&type=script&lang=js&"
export * from "./DeclareApplyList.vue?vue&type=script&lang=js&"
import style0 from "./DeclareApplyList.vue?vue&type=style&index=0&id=af9558cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9558cc",
  null
  
)

export default component.exports